interface SessionTimeoutProps {
  open: boolean
  onStayLoggedIn: () => void
  onLogOut: () => void
}

const StarIcon = () => (
  <svg width="22" height="22" viewBox="0 0 18 18" fill="none" aria-hidden="true">
    <path d="M9 1.5L10.6 7.4L16.5 9L10.6 10.6L9 16.5L7.4 10.6L1.5 9L7.4 7.4L9 1.5Z" fill="#000" stroke="#000" strokeWidth="0.4" strokeLinejoin="round"/>
  </svg>
)

export function SessionTimeout({ open, onStayLoggedIn, onLogOut }: SessionTimeoutProps) {
  if (!open) return null

  return (
    <>
      <div className="v2-session-overlay" role="dialog" aria-modal="true" aria-labelledby="v2SessionTitle">
        <div className="v2-session-logo">
          <div className="v2-session-logo-mark"><StarIcon /></div>
          <span className="v2-session-logo-name">AIRA</span>
        </div>
        <div className="v2-session-title" id="v2SessionTitle">You've been inactive for a while</div>
        <div className="v2-session-sub">Would you like to stay logged in?</div>
        <div className="v2-session-steps">
          <div className="v2-session-step">
            <div className="v2-step-num">1</div>
            <div className="v2-step-txt"><h4>Stay logged in</h4><p>Continue your current session</p></div>
          </div>
          <div className="v2-session-step">
            <div className="v2-step-num">2</div>
            <div className="v2-step-txt"><h4>Log out</h4><p>End your session securely</p></div>
          </div>
        </div>
        <div className="v2-session-actions">
          <button type="button" className="v2-session-btn primary" onClick={onStayLoggedIn}>Stay logged in</button>
          <button type="button" className="v2-session-btn secondary" onClick={onLogOut}>Log out</button>
        </div>
      </div>
    </>
  )
}
